module.exports = __webpack_public_path__ + "static/pittsburgh-3d539f42dffc074024bd1e8e124f810f.png";